import React from 'react';
import { motion } from 'framer-motion';
import { Clock, CheckCircle } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 bg-slate-800 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-158">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-slate-900 to-slate-800 border border-slate-700 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-160">
          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-161">
            <Clock className="w-10 h-10 text-amber-500" data-id="element-162" />
            <h2 className="text-3xl md:text-5xl font-oswald font-bold text-white uppercase" data-id="element-163">
              Lo que cambia en <span className="text-amber-500" data-id="element-164">7 días</span>
            </h2>
          </div>

          <div className="space-y-8" data-id="element-165">
            <div className="relative pl-8 md:pl-0" data-id="element-166">
              <div className="md:hidden absolute left-0 top-2 bottom-0 w-1 bg-slate-700 rounded-full" data-id="element-167"></div>

              <div className="flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-168">
                <div className="hidden md:flex flex-shrink-0 w-32 justify-end pr-6 border-r-2 border-slate-700" data-id="element-169">
                  <span className="font-oswald text-xl text-slate-500 uppercase" data-id="element-170">
                    Hoy
                  </span>
                </div>
                <div className="md:hidden absolute left-[-5px] top-2 w-3 h-3 rounded-full bg-slate-500" data-id="element-171"></div>
                <p className="text-xl text-slate-400" data-id="element-172">
                  Te sientes intimidado por un camión de 18 ruedas y el manual
                  técnico te parece imposible.
                </p>
              </div>
            </div>

            <div className="relative pl-8 md:pl-0" data-id="element-173">
              <div className="flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-174">
                <div className="hidden md:flex flex-shrink-0 w-32 justify-end pr-6 border-r-2 border-emerald-500" data-id="element-175">
                  <span className="font-oswald text-2xl text-emerald-500 uppercase font-bold" data-id="element-176">
                    Día 7
                  </span>
                </div>
                <div className="md:hidden absolute left-[-6px] top-2 w-4 h-4 rounded-full bg-emerald-500 shadow-[0_0_10px_rgba(16,185,129,0.8)]" data-id="element-177"></div>
                <p className="text-xl text-white font-medium leading-relaxed" data-id="element-178">
                  Entenderás exactamente cómo funciona el sistema de aire, por
                  qué el remolque se mueve como un látigo y qué palabras buscar
                  en la pantalla del DMV para que la computadora te dé la luz
                  verde de{' '}
                  <span className="inline-flex items-center gap-1 text-emerald-400 bg-emerald-500/10 px-2 py-1 rounded" data-id="element-179">
                    <CheckCircle className="w-5 h-5" data-id="element-180" /> APROBADO
                  </span>
                  .
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}